





























































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Emit } from 'vue-property-decorator';
import colors from 'vuetify/es5/util/colors';
import { TicketStatus } from '@/modules/shared/shared/domain/constants/constants';

@Component
export default class TicketFilter extends Vue {
    @Emit('closeDialog')
    closeDialog() {
        this.emptyFilters();
        this.dateChange();
        this.$emit('getFilters');
        return false;
    }

    typeFilterSelected: string[] = [];
    statusFilterSelected: string[] = [];
    dates: string[] = [];
    minDate: string = '';

    dateChange() {
        if (this.dates[0] !== '') {
            this.minDate = this.dates[0];
        } else {
            this.minDate = '';
        }
    }

    closePill(pill: { id: number; name: string; type: string; color: string }) {
        if (pill.type == 'T' && this.typeFilterSelected !== []) {
            for (var i = 0; i < this.typeFilterSelected.length; i++) {
                if (this.typeFilterSelected[i] == pill.name) {
                    this.typeFilterSelected.splice(i, 1);
                }
            }
        } else if (pill.type == 'D' && this.dates !== []) {
            this.dates = [];
            this.dateChange();
        } else if (pill.type == 'E' && this.statusFilterSelected !== []) {
            for (var k = 0; k < this.statusFilterSelected.length; k++) {
                if (this.statusFilterSelected[k] == pill.name) {
                    this.statusFilterSelected.splice(k, 1);
                }
            }
        }
    }

    get filtersSelected() {
        let auxFilters: {
            id: number;
            name: string;
            type: string;
            color: string;
        }[] = [];
        let abi: boolean = true;
        let sol: boolean = true;
        let fin: boolean = true;
        if (this.$store.state.filters.values !== undefined) {
            for (let index = 0; index < this.typeFilterSelected.length; index++) {
                for (let indx = 0; indx < this.typesSelect.length; indx++) {
                    if (this.typeFilterSelected[index] == this.typesSelect[indx].name) {
                        auxFilters.push({
                            id: this.typesSelect[indx].id,
                            name: this.typesSelect[indx].name,
                            type: 'T',
                            color: 'rgb(104,176,61)',
                        });
                    }
                }
            }
            for (let index = 0; index < this.statusFilterSelected.length; index++) {
                for (let indx = 0; indx < this.statusSelect.length; indx++) {
                    if (this.statusFilterSelected[index] == this.statusSelect[indx].name) {
                        if (this.statusSelect[indx].name == TicketStatus.OPENED && abi) {
                            abi = false;
                            auxFilters.push({
                                id: this.statusSelect[indx].id,
                                name: this.statusSelect[indx].name,
                                type: 'E',
                                color: 'rgb(51,73,138)',
                            });
                        } else if (this.statusSelect[indx].name == TicketStatus.FIXED && sol) {
                            sol = false;
                            auxFilters.push({
                                id: this.statusSelect[indx].id,
                                name: this.statusSelect[indx].name,
                                type: 'E',
                                color: 'rgb(51,73,138)',
                            });
                        } else if (
                            (this.statusSelect[indx].name == TicketStatus.CLOSED ||
                                this.statusSelect[indx].name == 'Cerrado') &&
                            fin
                        ) {
                            fin = false;
                            auxFilters.push({
                                id: this.statusSelect[indx].id,
                                name: this.statusSelect[indx].name,
                                type: 'E',
                                color: 'rgb(51,73,138)',
                            });
                        }
                    }
                }
            }
            if (this.dates[0] !== undefined && this.dates[1] !== undefined) {
                auxFilters.push({
                    id: -100,
                    name: this.dates[0] + ' al ' + this.dates[1],
                    type: 'D',
                    color: 'rgb(229,47,87)',
                });
            }
            return auxFilters;
        } else {
            return [];
        }
    }

    get typesSelect() {
        let auxTicketType: { id: number; name: string }[] = [];
        if (this.$store.state.filters.values !== undefined) {
            for (
                let index = 0;
                index < this.$store.state.filters.values.ticketTypes.length;
                index++
            ) {
                auxTicketType.push({
                    id: this.$store.state.filters.values.ticketTypes[index].id,
                    name: this.$store.state.filters.values.ticketTypes[index].name,
                });
            }
            return auxTicketType;
        } else {
            return [];
        }
    }

    verifyDays() {
        if (this.dates[0] > this.dates[1]) {
            return false;
        } else {
            return true;
        }
    }

    get statusSelect() {
        let abi: boolean = true;
        let sol: boolean = true;
        let fin: boolean = true;
        let auxTicketStatus: { id: number; name: string }[] = [];
        if (this.$store.state.filters.values !== undefined) {
            for (
                let index = 0;
                index < this.$store.state.filters.values.ticketStatuses.length;
                index++
            ) {
                if (
                    this.$store.state.filters.values.ticketStatuses[index].status ==
                        TicketStatus.OPENED &&
                    abi == true
                ) {
                    abi = false;
                    auxTicketStatus.push({
                        id: this.$store.state.filters.values.ticketStatuses[index].id,
                        name: this.$store.state.filters.values.ticketStatuses[index].status,
                    });
                } else if (
                    this.$store.state.filters.values.ticketStatuses[index].status ==
                        TicketStatus.FIXED &&
                    sol == true
                ) {
                    sol = false;
                    auxTicketStatus.push({
                        id: this.$store.state.filters.values.ticketStatuses[index].id,
                        name: this.$store.state.filters.values.ticketStatuses[index].status,
                    });
                } else {
                    fin = false;
                    auxTicketStatus.push({
                        id: this.$store.state.filters.values.ticketStatuses[index].id,
                        name: TicketStatus.CLOSED,
                    });
                }
            }
            return auxTicketStatus;
        } else {
            return [];
        }
    }

    getTicketTypes() {
        let auxTicketType: string[] = [];
        for (let index = 0; index < this.typesSelect.length; index++) {
            auxTicketType.push(this.typesSelect[index].name);
        }
        return auxTicketType;
    }

    getTicketStatus() {
        let auxTicketStatus: string[] = [];
        for (let index = 0; index < this.statusSelect.length; index++) {
            auxTicketStatus.push(this.statusSelect[index].name);
        }
        return auxTicketStatus;
    }

    cancelFilters() {
        this.emptyFilters();
        this.dateChange();
        this.closeDialog();
    }

    get canFilter() {
        if (this.filtersSelected.length == 0) {
            return false;
        } else {
            return true;
        }
    }

    emptyDate() {
        this.dates = [];
        this.minDate = '';
    }

    emptyFilters() {
        this.typeFilterSelected = [];
        this.statusFilterSelected = [];
        this.dates = [];
    }

    @Emit('getFilters')
    getFilters() {
        return this.filtersSelected;
    }
}
